
import {Vue, Component, Prop, Watch} from "vue-property-decorator";
import {regex} from "@/utils/formRules";
import { TranslateResult } from "vue-i18n";
@Component({})
export default class Telephone extends Vue {
    public phone: string = "";
    public error: boolean = false;

    @Prop()
    public value: string;

    @Prop()
    public label: TranslateResult;

    @Prop()
    public errbol: boolean;

    @Prop()
    public autocomplete: string;

    @Prop({default: false})
    public disabled: boolean;

    @Watch("value")
    public handlerValue() {
        this.phone = this.value || "";
    }

    private mounted() {

        this.phone = this.value ? this.value : "";
        if (this.autocomplete === "off") {
            const telinput: any = this.$refs.telinput;
            telinput.$refs.input.autocomplete = this.autocomplete;
        }
    }

  private changeNumber(num, obj) {
    if (num) {
      if (obj.countryCode === "FR") {
        this.$emit("input", "00" + obj.countryCallingCode + obj.nationalNumber);
      } else {
        this.$emit("input", obj.number);
      }
      const tempPhone = this.phone.replace(/ /g, "");
      if (this.phone[0] === "+") {
        this.error = !regex.validPhoneNumber.test(tempPhone);
      } else if (tempPhone[0] === "0" && tempPhone.length > 1 && tempPhone[1] === "0") {
        this.error = !regex.validPhoneNumber.test(tempPhone);
      } else if (tempPhone[0] === "0" && tempPhone.length > 1 && tempPhone[1] !== "0") {
        this.error = !regex.validPhoneNumber.test("+" + obj.countryCallingCode +
          tempPhone.substring(1, tempPhone.length));
      } else {
        this.error = !regex.validPhoneNumber.test(tempPhone);
      }
    }
  }

    private validate(obj) {
        // this.error = !obj.valid && !!this.phone;
    }
}
